import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <AboutSection />
        <RankingSection />
        <UpdatesSection />
        <MediaSection />
        <FeaturesSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <CommentsSection />
        <CardsSection />
        <TopicsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}